import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserCrudTable = ({ users, language, onEdit, onDelete, onView }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(25);
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');

  const labels = {
    name: { en: 'Name', ar: 'الاسم' },
    phoneNumber: { en: 'Phone Number', ar: 'رقم الهاتف' },
    userType: { en: 'User Type', ar: 'نوع المستخدم' },
    actions: { en: 'Actions', ar: 'الإجراءات' },
    rowsPerPage: { en: 'Rows per page:', ar: 'الصفوف لكل صفحة:' },
    previous: { en: 'Previous', ar: 'السابق' },
    next: { en: 'Next', ar: 'التالي' }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedUsers = [...users]?.sort((a, b) => {
    const aVal = a?.[sortField];
    const bVal = b?.[sortField];
    if (sortDirection === 'asc') {
      return aVal > bVal ? 1 : -1;
    }
    return aVal < bVal ? 1 : -1;
  });

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedUsers?.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(sortedUsers?.length / recordsPerPage);

  return (
    <div className="overflow-hidden">
      <div className="overflow-x-auto scrollbar-custom">
        <table className="w-full min-w-[600px]">
          <thead className="bg-muted border-b border-border">
            <tr>
              <th className="px-4 py-3 md:px-6 md:py-4 text-left">
                <button
                  onClick={() => handleSort('name')}
                  className="flex items-center gap-2 text-xs md:text-sm font-semibold text-foreground hover:text-primary transition-smooth"
                >
                  {labels?.name?.[language]}
                  <Icon name={sortField === 'name' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={16} />
                </button>
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-left">
                <button
                  onClick={() => handleSort('phoneNumber')}
                  className="flex items-center gap-2 text-xs md:text-sm font-semibold text-foreground hover:text-primary transition-smooth"
                >
                  {labels?.phoneNumber?.[language]}
                  <Icon name={sortField === 'phoneNumber' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={16} />
                </button>
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-left">
                <button
                  onClick={() => handleSort('userType')}
                  className="flex items-center gap-2 text-xs md:text-sm font-semibold text-foreground hover:text-primary transition-smooth"
                >
                  {labels?.userType?.[language]}
                  <Icon name={sortField === 'userType' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={16} />
                </button>
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center text-xs md:text-sm font-semibold text-foreground">
                {labels?.actions?.[language]}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {currentRecords?.map((user) => (
              <tr key={user?.id} className="hover:bg-muted/50 transition-smooth">
                <td className="px-4 py-3 md:px-6 md:py-4">
                  <p className="text-sm md:text-base font-medium text-foreground">{user?.name}</p>
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4">
                  <p className="text-xs md:text-sm text-text-secondary">{user?.phoneNumber}</p>
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4">
                  <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1.5 rounded-full text-xs md:text-sm font-medium bg-primary/10 text-primary">
                    {user?.userType}
                  </span>
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4">
                  <div className="flex items-center justify-center gap-2">
                    <button
                      onClick={() => onView(user)}
                      className="p-1.5 md:p-2 rounded-lg hover:bg-primary/10 text-primary transition-smooth"
                      aria-label="View user"
                    >
                      <Icon name="Eye" size={16} />
                    </button>
                    <button
                      onClick={() => onEdit(user)}
                      className="p-1.5 md:p-2 rounded-lg hover:bg-warning/10 text-warning transition-smooth"
                      aria-label="Edit user"
                    >
                      <Icon name="Edit2" size={16} />
                    </button>
                    <button
                      onClick={() => onDelete(user)}
                      className="p-1.5 md:p-2 rounded-lg hover:bg-error/10 text-error transition-smooth"
                      aria-label="Delete user"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  
    </div>
  );
};

export default UserCrudTable;